import http from "~/common/http";

export const  BranchModel = {
    id: 0,
    name: "",
    parent_id: 0,
    is_business: 0,
    memo: ""
};

export const BranchService = {

    /**
     * 创建部门
     * @param branch
     * @returns {*}
     */
    create(branch) {
        return http.post('/api/rbac/branches/create', branch);
    },

    /**
     * 编辑部门信息
     * @param branch
     * @returns {IDBRequest | Promise<void>}
     */
    update(branch) {
        return http.put('/api/rbac/branches/update?id=' + branch.id, branch);
    },

    /**
     * 删除部门信息
     * @param branchId
     * @returns {*}
     */
    delete(branchId) {
        return http.delete('/api/rbac/branches/delete?id=' + branchId);
    },

    /**
     * 得到部门信息
     * @param branchId
     * @returns {*}
     */
    getBranchInfo(branchId) {
        return http.get('/api/rbac/branches/view', {
            params: {id: branchId}
        })
    },

    /**
     * 得到部门列表树
     * @param params
     * @returns {*}
     */
    getTreeStructure(params) {
        return http.get('/api/rbac/branches/index');
    },

    /**
     * 得到地区列表
     * @param cityId
     * @returns {*}
     */
    getDistricts(cityId) {
        return http.get('/api/rbac/branch-districts/districts', {
            params: {
                city_id: cityId
            }
        });
    },

    /**
     * 提交绑定业务区域
     * @param params
     * @returns {*}
     */
    bindDistrict(params) {
        return http.post('/api/rbac/branch-districts/bind', params);
    },

    /**
     * 解绑业务区域
     * @param branchId
     * @param districts
     * @returns {IDBRequest | Promise<void>}
     */
    unbindDistrict(branchId, districts) {
        return http.put('/api/rbac/branch-districts/unbind?branch_id=' + branchId, {
            districts: districts
        })
    },

    /**
     * 得到部门绑定的地区列表
     * @param branchId
     * @returns {*}
     */
    getBranchDistricts(branchId) {
        return http.get('/api/rbac/branch-districts/index', {
            params: {branch_id: branchId}
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/Branch.js